import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { fullName } from 'src/adapters';
import { SubTitle } from '../../containers';
import { EStoreClientRequestForm } from '../EStore.types';
import { eStoreAgenciesForSelectSelector } from '../store';
import { RecapInfoItem } from './RecapInfoItem';

type Props = {
  testID?: string;
  recapInfos: EStoreClientRequestForm;
};

export const EStoreRecapContent: React.FC<Props> = ({ testID = 'EStoreRecapContent', recapInfos }) => {
  const { t } = useTranslation();

  const agencies = useSelector(eStoreAgenciesForSelectSelector);

  const toAgencyName = useMemo(() => {
    if (!recapInfos.toAgency) {
      return '';
    }
    const agency = agencies.find((item) => item.value === recapInfos.toAgency);

    if (!agency) {
      return '';
    }

    return agency.label;
  }, [agencies, recapInfos.toAgency]);
  return (
    <div data-testid={testID} className="">
      <SubTitle label={recapInfos.senderIsNotReceiver ? 'estore-recap.sender-title' : 'estore-recap.receiver-title'} />
      <div>
        <RecapInfoItem
          label={recapInfos.senderIsNotReceiver ? 'estore-recap.sender' : 'estore-recap.receiver'}
          value={fullName(recapInfos.sender)}
        />
        <RecapInfoItem label="estore-recap.tel" value={recapInfos.sender.tel} />
        {!!recapInfos.sender.email && <RecapInfoItem label="estore-recap.email" value={recapInfos.sender.email} />}
      </div>
      {recapInfos.senderIsNotReceiver && !!recapInfos.receiver && (
        <div>
          <SubTitle label="estore-recap.receiver-title" />
          <div>
            <RecapInfoItem label="estore-recap.receiver" value={fullName(recapInfos.receiver)} />
            <RecapInfoItem label="estore-recap.tel" value={recapInfos.receiver.tel} />
            {!!recapInfos?.receiver?.email && (
              <RecapInfoItem label="estore-recap.email" value={recapInfos?.receiver.email} />
            )}
          </div>
        </div>
      )}

      <div>
        <SubTitle label="estore-recap.colis-screen" />
        <div>
          <RecapInfoItem label="estore-recap.nb-colis" value={recapInfos.colisNumber.toString()} />
          <RecapInfoItem
            label="estore-recap.message"
            value={recapInfos.description?.replace(/(?:\r\n|\r|\n)/g, '<br />')}
          />
        </div>
      </div>

      <div>
        <SubTitle label="estore-recap.agency" />
        <RecapInfoItem label="estore-recap.to-agency" value={toAgencyName} />
      </div>
    </div>
  );
};
